import { render, staticRenderFns } from "./GraphDetail13.vue?vue&type=template&id=47b81862&scoped=true"
import script from "./GraphDetail13.vue?vue&type=script&lang=js"
export * from "./GraphDetail13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b81862",
  null
  
)

export default component.exports